import { createAction } from 'redux-actions';
import * as types from './system-message-constants';

export const getSystemMessages = createAction(types.SYSTEM_MESSAGE_REQUEST);
export const systemMessagesSuccess = createAction(types.SYSTEM_MESSAGE_SUCCESS);
export const systemMessagesFailure = createAction(types.SYSTEM_MESSAGE_FAILURE);

export const discardSystemMessageRequest = createAction(types.DISCARD_SYSTEM_MESSAGE_REQUEST);
export const discardSystemMessageSuccess = createAction(types.DISCARD_SYSTEM_MESSAGE_SUCCESS);
export const discardSystemMessageFailure = createAction(types.DISCARD_SYSTEM_MESSAGE_FAILURE);

export const unlockSystemMessageRequest = createAction(types.UNLOCK_SYSTEM_MESSAGE_REQUEST);
export const unlockSystemMessageSuccess = createAction(types.UNLOCK_SYSTEM_MESSAGE_SUCCESS);
export const unlockSystemMessageFailure = createAction(types.UNLOCK_SYSTEM_MESSAGE_FAILURE);

export const toggleMessageCenter = createAction(types.TOGGLE_MESSAGE_CENTER);
